<div class="details-container">
  <div class="details-header" style="background: url(assets/images/bex2.jpg)">
    <div class="details-banner">
      <h1>Trafford Grammar Schools</h1>
      <h2>11 Plus (11+) Exam Information</h2>
    </div>
  </div>

  <div class="details-publisher">
    <span><strong>Published by - SEHYOG Academy</strong></span>
  </div>

  <div class="details-content">
    <div class="details-section">
      <h3>Introduction</h3>

      <div class="spacer"></div>

      <p>
        In the UK, grammar school consortia are cooperative alliances of grammar
        schools that collaborate to facilitate entrance exams. These consortia
        are usually established by a cluster of grammar schools within a
        specific area or region, joining forces to develop a unified entrance
        examination process. <br />
        <br />

        For many years, the Trafford Grammar Schools Consortium has played a
        crucial role in the selective education system in Trafford, introducing
        a standardised process for admitting students based on their academic
        abilities. <br />
        <br />

        All the member schools within the Trafford Grammar School Consortium
        administer a unified entrance test, ensuring fairness and consistency
        throughout the admissions process. As a result, students only need to
        take the test once, even if they are applying to multiple schools within
        the consortium. <br />
        <br />

        The primary objective of the Trafford Consortium is to streamline the
        admissions process for its grammar schools and maintain a consistent
        selection procedure. The consortium facilitates collaboration amongst
        the grammar schools, fostering resource sharing, exchange of expertise
        and efficient administrative efforts. This collective approach aims to
        provide equal opportunities for students from diverse backgrounds to
        access high-quality education.
      </p>

      <div class="spacer"></div>

      <h2>Complete List of Grammar Schools in Trafford</h2>

      <p>
        There are currently five grammar schools in the Trafford Grammar School
        Consortium:
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <table>
        <tr>
          <th>School Name</th>
        </tr>
        <tr *ngFor="let school of schools">
          <td>
            <a [href]="school.url" target="_blank">{{ school.name }}</a>
          </td>
        </tr>
      </table>

      <div class="spacer"></div>

      <p>⬇️ Read on to learn more about their exam and admissions process!</p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>11 Plus (11+) Exam Information for Trafford Grammar Schools</h2>

      <p>
        The Trafford Consortium entrance exam results serve as a unified
        criterion for admission decisions across the participating grammar
        schools. Students who exhibit outstanding performance in the 11+ exam
        will be potentially eligible for admission to multiple schools within
        the consortium. This increases their chances of securing a grammar
        school place. Here are some essential details regarding the Trafford 11+
        exam:
      </p>

      <p><strong>Registration closing date: </strong> June</p>
      <p>
        <strong>Common Application Form (CAF) closing date:</strong> October
      </p>
      <p><strong>Exam date:</strong> September</p>
      <p><strong>Exam board type:</strong>GL Assessment</p>
      <p>
        <strong>Pass mark: </strong> Aim for 75-80%+ in our practice tests. See
        below for more details.
      </p>
      <p><strong>Results date:</strong>October</p>
      <p><strong>Allocations date: </strong>March</p>
      <p>
        <strong>Admissions info: </strong> L school.admissions&#64;trafford.gov.uk,
        0161 912 5007
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Trafford Grammar Schools 11 Plus (11+) Admissions</h2>

      <div class="spacer"></div>

      <p>
        Year 7 admission to any of the five grammar schools in Trafford is
        determined by pupil performance in the 11 Plus exam. Each of the schools
        hosts an open event annually, typically in the summer term. <br />
        <br />

        Attending an Open Day/Evening will provide you and your child with the
        unique opportunity to tour the relevant school’s campus, as well as
        speak to members of staff and ask questions about the admissions
        process. <br />
        <br />

        While all five schools are part of the Trafford Grammar Schools
        Consortium, they are each responsible for their own admissions into Year
        7. Each of the schools within the Consortium use the same 11+ test.
        <br />
        <br />
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>
        How to Register for the Trafford Grammar Schools 11 Plus (11+) Exam
      </h2>
      <div class="spacer"></div>

      <p>
        To apply for a place at one of Trafford’s grammar schools on behalf of
        your child, you must register them for the 11 Plus entrance examination.
        Online forms are available on each school’s admissions page when
        registration is open and should be submitted by the deadline in June of
        the year preceding entry. In addition to completing the registration
        form, you also need to complete the Local Authority’s Common Application
        Form (CAF) by the deadline in October and list the preferred schools in
        ranked order.
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Trafford Grammar Schools 11 Plus (11+) Exam Format</h2>

      <div class="spacer"></div>

      <div>
        <img src="assets/images/check-list.png" alt="" />
        <p>Mathematics</p>
      </div>

      <div>
        <img src="assets/images/check-list.png" alt="" />
        <p>Verbal Reasoning (including Comprehension)</p>
      </div>

      <div>
        <img src="assets/images/check-list.png" alt="" />
        <p>Non-Verbal Reasoning (including Spatial Reasoning)</p>
      </div>

      <p>
        The topics evaluated in the test are as follows:

        <strong>➢ Mathematics: </strong> These sections assess students’
        mathematical skills, problem-solving abilities and logical reasoning.
        The exam will include questions that test number operations, algebra,
        geometry, measurement, statistics and data handling.

        <strong>➢ Verbal Reasoning:</strong> These sections test your child’s
        reasoning skills using language-based tasks, such as identifying
        patterns, completing analogies, solving codes and making logical
        deductions. They also measure your child’s ability to think critically
        and analyse information. These sections will include Comprehension
        questions, too.

        <strong>➢ Non-Verbal Reasoning (NVR):</strong> These sections test
        students’ ability to solve problems using visual and abstract reasoning.
        They do not rely on language skills but instead challenge students to
        identify patterns, relationships and sequences within shapes, figures
        and diagrams.

        <strong>➢ Spatial Reasoning:</strong> These sections are designed to
        assess students’ ability to understand and manipulate visual
        representations of objects and space. Spatial Reasoning tests spatial
        awareness, mental rotation, visualisation and problem-solving skills.
        <br />
        <br />
      </p>

      <p>
        Students will be given a separate age-standardised score for each of the
        three subject areas: <br />
        <br />

        1. Verbal Ability – Comprehension, Technical English and VR 2. Numerical
        Ability – Mathematics 3. Non-Verbal Ability – NVR and Spatial Reasoning

        <br />
        <br />

        One total age-standardised score will then be used to decide whether
        your child is eligible for entry. The total score is weighted, by
        combining 50% of the Verbal Ability score, 25% of the Numerical Ability
        score and 25% of the Non-Verbal Ability score.
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Trafford 11 Plus (11+) Exam Pass Marks and Target Scores</h2>

      <div class="spacer"></div>

      <p>
        Grammars that belong to the Trafford Consortium have a GL-style 11+ exam
        and a standardised pass mark for 11 plus applicants. The standardised
        qualifying score for these schools is 334 or above. <br />
        <br />

        Loreto Grammar School and St Ambrose College don’t belong to the
        consortium and their exams differ. Loreto will offer places to the top
        150 applicants, while St Ambrose will admit the best 140 applicants,
        based on their total scores. <br />
        <br />

        Pupils who are able to score 75-80%+ consistently in our 11+ practice
        tests should be on track to pass the 11+ test.<br />
        <br />

        Whilst there are no guarantees, this is a fairly strong indicator that
        your child should do well in the Trafford 11+ exam.<br />
        <br />

        Passing the test does not guarantee that your child will be offered a
        place. It simply means they have surpassed the required threshold. As
        such, it makes sense to aim for as high a score as possible. <br />
        <br />

        Don’t worry if your child is not scoring well in our practice papers
        from the outset. With targeted practice and focus, it’s possible to make
        big improvements in a short amount of time!<br />
        <br />
      </p>

      <h2>Trafford Grammar Schools: Results & Leavers’ Destinations</h2>

      <p>
        <strong>Trafford Grammar Schools – Progress 8 Scores</strong> <br />
        <br />

        Progress 8 is an evaluative measure used to gauge the progress students
        achieve during their transition from primary school (end of Key Stage 2)
        to secondary school (end of Key Stage 4). It offers valuable insights
        into the quality of education provided by schools by assessing the
        academic advancement of students. <br />
        <br />

        To determine Progress 8 scores, students’ actual achievements across
        eight core subjects, including English, mathematics, sciences,
        humanities and languages, are compared to their anticipated
        accomplishments. These expectations are established based on their prior
        attainment at the end of primary school. The score is determined by
        evaluating the average progress made by students across these subjects.
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Trafford Grammar Schools – Leavers’ Destinations</h2>

      <p>
        Leavers’ destinations here refer to the next steps that students take
        after completing their studies at Trafford grammar schools. <br />
        <br />

        Russell Group universities are esteemed institutions globally,
        recognised for their remarkable achievements across multiple important
        measures. These universities demonstrate exceptional research
        contributions, housing distinguished scholars and groundbreaking
        discoveries. Their academic reputation is exemplary, attracting talented
        individuals from all corners of the globe. <br />
        <br />

        Within the distinguished selection of Russell Group members, the
        University of Oxford and the University of Cambridge stand out
        prominently. These institutions boast rich histories of academic
        excellence and rigorous educational programmes. With renowned faculty
        and an unwavering commitment to excellence, Oxbridge have maintained
        their prestigious status for centuries. <br />
        <br />
      </p>

      <h2>
        Frequently Asked Questions About The 11 Plus (11+) Trafford Grammar
        School Consortium
      </h2>

      <p>
        <strong>Does Trafford have grammar schools?</strong>
        <br />
        <br />

        Yes, Trafford has five selective grammar schools. Click here to access
        the articles we have for each of these schools, addressing their values
        and ethos, as well as all the details about their 11+ entry procedure.
        <br />
        <br />

        <strong>When should students apply for the Trafford 11+ exam?</strong>
        <br />
        <br />

        The deadline to register via the Local Authority is in June of the year
        preceding entry. A Common Application Form must also be submitted (prior
        to the October deadline), listing your preferred schools in a ranked
        order.<br />
        <br />

        <strong>What's the date of the Trafford 11+ exam?</strong>
        <br />
        <br />

        Grammar schools in the Trafford Consortium hold their 11+ exam in
        September. <br />
        <br />

        <strong>What comes up in the Trafford 11+ exam?</strong> <br />
        <br />

        The Trafford test consists of two papers, each lasting approximately an
        hour and testing Mathematics, Verbal Reasoning and Non-Verbal Reasoning
        (including Spatial Reasoning).
        <br />
        <br />

        <strong>What is the pass mark at Trafford grammar schools?</strong>
        <br />
        <br />

        Grammars that belong to the Trafford Consortium have a GL-style 11+ exam
        and a standardised pass mark for 11 plus applicants. Pupils who are able
        to score 75-80%+ consistently in our 11+ practice tests should be on
        track to pass the 11+ test.
        <br />
        <br />
        <strong>Which publisher provides the Trafford 11+ exam?</strong> <br />
        <br />

        Trafford’s grammar schools use GL Assessment as their 11+ exam provider.
      </p>

      <div class="spacer"></div>
    </div>
  </div>
</div>
